"use strict";

require("core-js/modules/es6.object.define-properties");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.string.bold");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.maxWidth = exports.bold = exports.regular = exports.caps = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledSystem = require("styled-system");

var _theme = _interopRequireDefault(require("./theme"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var caps = function caps(props) {
  return props.caps && {
    textTransform: 'uppercase'
  };
};

exports.caps = caps;

var regular = function regular(props) {
  return props.regular && {
    fontWeight: 'regular'
  };
};

exports.regular = regular;

var bold = function bold(props) {
  return props.bold && {
    fontWeight: 'bold'
  };
};

exports.bold = bold;

var maxWidth = function maxWidth(_ref) {
  var maxWidth = _ref.maxWidth;
  return maxWidth && {
    maxWidth: "".concat(maxWidth, "rem")
  };
};

exports.maxWidth = maxWidth;

var Text = _styledComponents["default"].p([], _styledSystem.fontSize, _styledSystem.space, _styledSystem.color, caps, _styledSystem.textAlign, bold, regular, _styledSystem.fontWeight, maxWidth);

Text.displayName = 'Text';
Text.propTypes = _objectSpread({
  caps: _propTypes["default"].bool,
  regular: _propTypes["default"].bool,
  bold: _propTypes["default"].bool,
  maxWidth: _propTypes["default"].number
}, _styledSystem.propTypes.fontSize, {}, _styledSystem.propTypes.fontWeight, {}, _styledSystem.propTypes.textAlign, {}, _styledSystem.propTypes.space, {}, _styledSystem.propTypes.color);
Text.defaultProps = {
  theme: _theme["default"],
  m: 0
};
Text.span = Text.withComponent('span');
Text.p = Text.withComponent('p');
Text.s = Text.withComponent('s');
var _default = Text;
exports["default"] = _default;